// import { authGuard } from "../auth";
import { routes as dashboard } from "../modules/dashboard";
// import { routes as investment } from "../modules/investment/investment.module";
import { routes as performance } from "../modules/performance/performance.module";
import { routes as marketplace } from "../modules/marketplace/marketplace.module";
import { routes as add_account } from "../modules/add-account";
import { routes as account } from "../modules/account/account.module";
import { routes as ranking } from "../modules/ranking/ranking.module";
import { routes as admin } from "../modules/admin/admin.module";
import { routes as partners } from "../modules/partners/partners.module";
import { routes as payment } from "../modules/payment/payment.module";
import { routes as layoutInvestment } from "../modules/layout-investment/investment.module";
import { routes as portfolio } from "../modules/portfolio/portfolio.module";
import { routes as championship } from "../modules/contests/contests.module";
import { routes as longshort } from "../modules/longshort/longshort.module";
// import { routes as trade_ideas } from "../modules/trade-ideas/trade-ideas.module";
import { routes as trade_ideas_v2 } from "../modules/trade-ideas-v2/trade-ideas.module";
import { routes as testing } from "../modules/testing/testing.module";
// import { routes as checkout } from "../modules/checkout/checkout.module";
import { routes as chart } from "../modules/chart/chart.module";
import { routes as bests } from "../modules/bests/bests.module";

export default [
  {
    path: "/",
    component: () => import("../shared/components/container/container.component.vue"),
    children: [
      ...dashboard,
      // ...investment,
      ...performance,
      ...marketplace,
      ...account,
      ...add_account,
      ...ranking,
      ...admin,
      ...partners,
      ...payment,
      ...layoutInvestment,
      ...portfolio,
      ...championship,
      ...longshort,
      // ...trade_ideas, // FIXME: (trade_ideas) TEMPORÁRIO
      ...trade_ideas_v2,
      ...testing,
      ...chart,
      // ...bests,
      // {
      //   path: "/:catchAll(.*)",
      //   component: () =>
      //     import(
      //       "@/app/shared/components/basic/ontick-catch-all.component.vue"
      //     ),
      //   name: "Erro",
      // },
    ],
    meta: { requiresAuth: true },
  },

  {
    path: "/auth",
    name: "Auth",
    component: () => import("@/app/modules/auth/pages/auth.component.vue"),
  },

  {
    path: "/email-validate",
    name: "Email validate",
    component: () => import("@/app/modules/auth/pages/email.component.vue"),
  },
  {
    path: "/checkout/:checkout_code", // ?coupon=abcdef
    name: "Checkout",
    component: () => import(/* webpackChunkName: "checkout" */ "@/app/modules/checkout/pages/checkout.component.vue"),
  },
  {
    path: "/checkout-confirm", // ?return_uuid=uuidv4
    name: "Confirmação de compra",
    component: () =>
      import(/* webpackChunkName: "checkout-confirm" */ "@/app/modules/checkout/pages/payment-confirm.component.vue"),
  },

  {
    path: "*",
    component: () => import("@/app/shared/components/not-found.component.vue"),
  },
];
